angular
    .module('festzelt-os.modules.bo.option-links', [
        'ui.router',
        'festzelt-os.components'
    ]);

// require('./routes');
// Components
require('./components/entity-option-links/component');

// Controllers
// require('./controllers/details-controller');
// require('./controllers/edit-controller');
// require('./controllers/list-controller');

// Factories
require('./factories/option-link-factory');
require('./store/option-links');

// Workflows
require('./workflows/option-links-list/export-option-links');
require('./workflows/option-links-list/delete-option-links');



// WEBPACK FOOTER //
// ./src/app/modules/bo/option-links/module.js